import { render, staticRenderFns } from "./roll-tab.vue?vue&type=template&id=58045c60&"
import script from "./roll-tab.vue?vue&type=script&lang=js&"
export * from "./roll-tab.vue?vue&type=script&lang=js&"
import style0 from "./roll-tab.vue?vue&type=style&index=0&id=58045c60&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports